// extracted by mini-css-extract-plugin
export default {"root":"IXNbdurBs_hWeclDl6FX","disabled":"khXHT10h9SVwcsm_x8M8","placeHolderShimmer":"mQy_PRwgdWIpvcPHwm0h"};